// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const SupplierService = {};

SupplierService.addSupplier = function (data) {
  console.log("🚀 ~ data:", data);
  // data.SupplierKelurahan = "BLONDO";
  // data.NPWPSupplierKecamatan = "BLONDO";
  console.log("🚀 ~getSupplierService data:", data);
  return lossClient({
    url: "/Supplier/add",
    method: "post",
    data: data,
  });
};

SupplierService.getSupplerApproval = function (userInput) {
  console.log("🚀 ~ userInputgetSupplerApproval:", userInput);
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  return lossClient({
    url:
      "/Supplier/approvalSuppliers?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.prodCod,
    method: "get",
  });
};

SupplierService.getSupplerItemSerch = function (userInput) {
  // console.log("🚀 ~ usergetSupplerItemSerch:", userInput);
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  return lossClient({
    url:
      "/Supplier/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&name=" +
      userInput.prodCod +
      "&code=" +
      userInput.code,
    method: "get",
  });
};

SupplierService.getSupplerItem = function (userInput) { 
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  return lossClient({
    url:
      "/Supplier/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.prodCod +
      "&name=" +
      userInput.name +
      "&supplierType=" +
      userInput.supplierType,
    method: "get",
  });
};

SupplierService.getSupplierEmployeeService = function (userInput) {
  // console.log("🚀 ~ userInputgetSupplerItem:", userInput);
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  return lossClient({
    url:
      "/SupplierEmployee/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&supplierid=" +
      userInput.supplierid +
      "&name=" +
      userInput.name +
      "&position=" +
      userInput.position,
    method: "get",
  });
};

SupplierService.supplierReturn = function (data) {
  return lossClient({
    url: `/Supplier/return`,
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: {
      Note: data.note,
      userId: data.userId,
    },
  });
};

SupplierService.supplierReject = function (data) {
  return lossClient({
    url: `/Supplier/reject`,
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: {
      Note: data.note,
      userId: data.userId,
    },
  });
};

SupplierService.SupplerApproval = function (data) {
  console.log("🚀 ~ SupplerApprovaldata:", data);
  return lossClient({
    url: `/Supplier/approve`,
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: {
      Note: data.note,
      userId: data.userId,
    },
  });
};

SupplierService.SupplierRequest = function (data) {
  console.log("🚀 ~ SupplerApprovaldata:", data);
  return lossClient({
    url: `/Supplier/request`,
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: {
      Request: data.Request,
      Note: data.note,
      userId: data.userId,
    },
  });
};

SupplierService.deleteSupplier = function (data) {
  return lossClient({
    url: `/Supplier/delete`,
    method: "delete",
    headers: {
      "x-RequestId": data.id,
    },
    data: {
      userId: data.userId,
    },
  });
};
export default SupplierService;
